import '@operato/input/ox-input-secret.js'

import { OxGristEditor } from './ox-grist-editor.js'
import { customElement } from 'lit/decorators.js'
import { html } from 'lit'

@customElement('ox-grist-editor-secret')
export class OxGristEditorSecret extends OxGristEditor {
  get editorTemplate() {
    return html`
      <ox-input-secret
        .value=${this.value}
        @change=${this._onchange}
        @keydown=${this._onkeydown}
        @focusout=${this._onfocusout}
      >
      </ox-input-secret>
    `
  }
}
